import Image from "next/image";
import { cn } from "@/lib/utils";
import {User} from "lucide-react"

export default function Pfp({href, username, className, ...props}) {
    const extraClass = href ? "" : "flex items-end justify-center";
    return (
        <div className={cn('w-full h-full rounded-full overflow-hidden bg-muted relative', className, extraClass)} {...props}>
            {href ? (
                <Image
                    src={href}
                    alt={`${username}'s profile picture`}
                    width={64}
                    height={64}
                    fill
                    className="object-cover"
                />
            ) : (
                <User className="w-[85%] h-[85%]"/>
            )}
        </div>
    );
}
